import React from "react";

const PRESETS = [
  { days: 1, label: "1d" },
  { days: 3, label: "3d" },
  { days: 7, label: "7d" },
  { days: 30, label: "30d" },
  { days: 90, label: "90d" },
];

export function DateRangeFilter({ days, onChange }) {
  return (
    <div className="ou-daterange" role="group" aria-label="Date range">
      {PRESETS.map((p) => (
        <button
          key={p.days}
          type="button"
          onClick={() => onChange(p.days)}
          className={days === p.days ? "is-active" : ""}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
